if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
      this.thumbnails = [...this.querySelectorAll('[data-carousel-thumbnail]')];
      this.status = this.querySelector('[data-carousel-status]');
      this.currentIndex = 0;
      this.touchStartX = null;

      this.classList.add('is-ready');
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1));
      this.thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => this.show(index)));

      if (this.slides.length < 2) return;

      this.addEventListener('keydown', (event) => this.onKeydown(event));
      this.addEventListener('touchstart', (event) => { this.touchStartX = event.changedTouches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });

      const variantSelector = this.closest('.product-layout')?.querySelector('.product-form select[name="id"]');
      variantSelector?.addEventListener('change', () => {
        const mediaId = variantSelector.selectedOptions[0]?.dataset.mediaId;
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
        if (index >= 0) this.show(index);
      });
    }

    show(index) {
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === this.currentIndex;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', String(active));
      });
      if (this.status) this.status.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
    }

    onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.show(this.currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.show(this.currentIndex + 1);
      }
    }

    onTouchEnd(event) {
      if (this.touchStartX === null) return;
      const distance = event.changedTouches[0].clientX - this.touchStartX;
      this.touchStartX = null;
      if (Math.abs(distance) < 45) return;
      this.show(this.currentIndex + (distance < 0 ? 1 : -1));
    }
  });
}
